import { render, staticRenderFns } from "./sos-dispose.vue?vue&type=template&id=8c643cee&"
import script from "./sos-dispose.vue?vue&type=script&lang=js&"
export * from "./sos-dispose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports